<div>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <label class="quicksand-normal-label">Please click on save after evaluating it!</label>
  <div #test style="width: 100%; height: 300px"></div>

  <button nbButton class="mt-2 save-btn float-right" (click)="saveGraphImageForOption()">Save</button>
</div>
